import { useQuery } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

type Props = {
    id: string;
};

export const getRefundRequest = async (id: string) => {
    try {
        const response = await Axios.get(`/refund-requests/${id}`);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useGetRefundRequest = ({ id }: Props) => {
    const requests = useQuery({
        queryKey: ["get_refund_request", id],
        queryFn: () => getRefundRequest(id),
        enabled: !!id,
    });

    return requests;
};
